/* eslint-disable no-use-before-define */
import React from 'react'

export const NotFound = ({stateName}) => {

    return <React.Fragment><div className="row">
    <div className="col-md-12">
        <h3 className="text-bold" style={{display:'inline'}}>{stateName}</h3>
    </div></div>

    <div data-name="loading-fail" className="row">
    <div className="col-md-12 text-center">
        <i className="et-icon et-alert et-icon-md" aria-hidden="true"></i>
        <div className="small-header">No trades found.</div>
    </div></div>
    </React.Fragment>
}



// WEBPACK FOOTER //
// ./src/municipals/map/tooltip/not-found.js